import React from "react";
import { Star, Users } from "lucide-react";

const TalentDashboardHeader = ({
  dashboardData,
  setShowFollowingModal,
  navigate
}) => {
  return (
    <div className="td-header d-flex justify-content-between align-items-center flex-wrap gap-3">
      <div>
        <h1 className="td-title">My Dashboard</h1>
        <p className="td-subtitle">Welcome back! Track your auditions and find your next big role.</p>
      </div>

      <div className="d-flex align-items-center gap-3 td-header-tiles-wrapper">
        {/* FOLLOWING TILE */}
        <div
          className="td-following-tile"
          onClick={() => setShowFollowingModal(true)}
          style={{
            cursor: "pointer",
            background: "rgba(255, 255, 255, 0.03)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            padding: "10px 16px",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            backdropFilter: "blur(10px)",
            transition: "all 0.3s ease"
          }}
          title="Click to view followed Casting Directors"
        >
          <div
            className="following-tile-icon-box"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              background: "rgba(59, 130, 246, 0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Users size={16} color="#3b82f6" />
          </div>
          <div className="following-tile-info" style={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0 }}>
            <span className="following-tile-label text-truncate" style={{ fontSize: "10px", fontWeight: "700", color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.8px" }}>Following</span>
            <span className="following-tile-count text-truncate" style={{ fontSize: "13px", fontWeight: "700", color: "#ffffff" }}>{dashboardData?.kpis?.followingCount || 0} CDs</span>
          </div>
        </div>

        {/* PROFILE SCORE TILE */}
        <div
          className="td-profile-score-tile"
          onClick={() => navigate("/dashboard/profile/edit")}
          style={{ cursor: "pointer" }}
          title="Click to edit your profile"
        >
          <div className="score-tile-icon-box">
            <Star size={16} fill="var(--td-accent-yellow)" color="var(--td-accent-yellow)" />
          </div>
          <div className="score-tile-info" style={{ minWidth: 0 }}>
            <span className="score-tile-label text-truncate">Profile Score</span>
            <div className="score-tile-progress-wrapper">
              <div className="score-tile-bar">
                <div className="score-tile-fill" style={{ width: dashboardData?.kpis?.profileScore || "0%" }}></div>
              </div>
              <span className="score-tile-percentage">{dashboardData?.kpis?.profileScore || "0%"}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TalentDashboardHeader;
